import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Iter 85.13 · Aggressive one-shot cache eviction on every page load.
//
// The historical PWA service worker (see /public/sw.js) is being replaced
// with a self-uninstalling variant to solve a real regression where
// freshly-deployed UI (a new ClientDetail tab) was invisible in partner
// browsers because of Cache Storage stashed by earlier SW versions. In
// addition to the SW's own activate-time eviction, we belt-and-suspenders
// unregister every SW and delete every Cache Storage bucket on each load
// so a stale bundle can never linger for more than a single navigation.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch (_) { /* ignore */ }
    try {
      if (typeof caches !== "undefined") {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (_) { /* ignore */ }
  });
}
